<template>
    <div class="page-pdf-container">
        <div class="pdf-header-opt">
            <el-button size="mini" @touchstart="idx = 0" @touchend="idx = -1" @click="scaleD">放大</el-button>
            <el-button size="mini" @touchstart="idx = 1" @touchend="idx = -1" @click="scaleX">缩小</el-button>
            <p class="mr10 ml10">当前第{{ currentPage }}页/共{{ pageCount }}页</p>
            <el-button size="mini" @touchstart="idx = 2" @touchend="idx = -1" @click="changePdfPage(0)">上一页</el-button>
            <el-button size="mini" @touchstart="idx = 3" @touchend="idx = -1" @click="changePdfPage(1)">下一页</el-button>
            <el-button size="mini" @touchstart="idx = 3" @touchend="idx = -1" @click="printPdf">打印</el-button>
        </div>
        <!--    <div class="main"> -->
        <pdf :src="src" :page="currentPage" @progress="loadedRatio = $event" @loaded="loadPdfHandler" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" ref="wrapper" class="pdf"></pdf>
        <!-- </div> -->
        <!-- <ul class="footers">
            <li :class="{ select: idx == 0 }" @touchstart="idx = 0" @touchend="idx = -1" @click="scaleD">
                <p class="more-p">放大</p>
            </li>
            <li :class="{ select: idx == 1 }" @touchstart="idx = 1" @touchend="idx = -1" @click="scaleX">
                <p class="small-p">缩小</p>
            </li>
            <li :class="{ select: idx == 2 }" @touchstart="idx = 2" @touchend="idx = -1" @click="changePdfPage(0)">
                <p class="up-p">上一页</p>
            </li>
            <li :class="{ select: idx == 3 }" @touchstart="idx = 3" @touchend="idx = -1" @click="changePdfPage(1)">
                <p class="down-p">下一页</p>
            </li>
            <li>
                <p>当前第{{ currentPage }}页/共{{ pageCount }}页</p>
            </li>
            <li class="home">
                <a href="/">返回首页</a>
            </li>
        </ul> -->
    </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
    props: {
        src: {
            type: String,
            default: "",
        },

    },
    data() {
        return {
            currentPage: 1, // 当前页码
            pageCount: 0, // 总页码
            scale: 60,
            idx: -1,
            loadedRatio: 0,
        };
    },
    watch: {
        src() {
            // this.src = pdf.createLoadingTask(this.src); // 处理一下跨域
        }
    },
    mounted() {
        // this.src = pdf.createLoadingTask(this.src); // 处理一下跨域
    },
    components: {
        pdf
    },
    methods: {
        // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
        changePdfPage(val) {
            if (val === 0 && this.currentPage > 1) {
                this.currentPage--;
            }
            if (val === 1 && this.currentPage < this.pageCount) {
                this.currentPage++;
            }
            console.log(this.currentPage);
            console.log(this.pageCount);
        },
        goBack() {
            this.$router.go(-1);
        },
        // pdf加载时
        loadPdfHandler(e) {
            this.currentPage = 1; // 加载的时候先加载第一页
        },
        //放大
        scaleD() {
            this.scale += 5;
            this.$refs.wrapper.$el.style.width = parseInt(this.scale) + "%";
        },

        //缩小
        scaleX() {
            // if (this.scale == 100) {
            //     return;
            // }
            this.scale += -5;
            this.$refs.wrapper.$el.style.width = parseInt(this.scale) + "%";
        },
        printPdf() { // 调用打印
            this.$refs.wrapper.print()
        }
    }
};

</script>
<style lang="scss" scoped>
.page-pdf-container {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .pdf {
        width: 60%;
        margin: 0 auto;
        flex: 1
    }

    .pdf-header-opt {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }
}

</style>
